import React from "react";
import { Link } from "react-router-dom";
import RightArrow from "../../../components/SVG";
import SectionTitleSpecial from "../../../components/SectionTitle/SectionTitleSpecial";
import aboutImg1 from "../../../assets/img/about/ed-about-2-1.png";
import aboutImg2 from "../../../assets/img/about/ed-about-2-3.png";
import aboutImg3 from "../../../assets/img/about/ed-about-2-2.png";
import shapeImg1 from "../../../assets/img/about/ed-shape-2-1.png";
import shapeImg2 from "../../../assets/img/about/ed-shape-2-2.png";
import titleImg from "../../../assets/img/about/title-home2.png";
import partners01 from "../../../assets/img/sap/partners/01.jpg";
import partners02 from "../../../assets/img/global.jpeg";
import partners03 from "../../../assets/img/sap/partners/03.jpg";

const PartnersSection = () => {
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-xxl-11 col-xl-10 col-lg-10">
          <div className="postbox__details-wrapper pt-50 pb-0">
            <div className="postbox__item text-center pb-0 pb-md-5">
              <i className="fas fa-quote-right"></i>
              <p>
                The Society of Aquaculture Professionals has entered into a
                Memorandum of Understanding with the following professional
                organizations in aquaculture and recognizes them as Strategic
                Partners.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="it-sv-details-top-wrap">
          <div className="row mb-0 mb-md-5">
            <div className="col-xl-4 col-lg-4">
              <div className="it-sv-details-top-thumb">
                <img src={partners01} alt="" />
              </div>
            </div>
            <div className="col-xl-8 col-lg-8">
              <div className="it-sv-details-top-content">
                <p>
                  The{" "}
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    World Aquaculture Society (WAS)
                  </span>
                  , commenced as a professional body for those working in
                  Mariculture, then expanding to all aspects of aquaculture and
                  today representing about 100 countries globally. With its head
                  office in the United States, it has created chapters in Japan,
                  Korea, Latin American and Caribbean region, Asian-Pacific
                  region and most recently in Africa. Apart from the annual
                  meeting of WAS which attracts aquaculture professionals from
                  across the world, it is also known for its renowned
                  publications the{" "}
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Journal of the World Aquaculture Society
                  </span>
                  , a bi-monthly scientific journal which contains high quality
                  scientific papers covering the range of aquaculture topics and
                  the{" "}
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    World Aquaculture Magazine
                  </span>{" "}
                  which provides a quarterly source of articles on aquaculture
                  and news of interest to WAS members.
                </p>
                <p>For more detailed information about WAS go to:</p>
                <a
                  href="https://www.was.org/"
                  target="black"
                  style={{ color: "#704fe6", fontWeight: "600" }}
                >
                  www.was.org
                </a>
              </div>
            </div>
          </div>
          <div className="row mb-0 mb-md-5">
            <div className="col-xl-8 col-lg-8 order-2 order-md-1">
              <div className="it-sv-details-top-content">
                <p>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    The Global Seafood Alliance (GSA)
                  </span>{" "}
                  is an international nongovernmental organization dedicated to
                  advancing responsible seafood practices worldwide through
                  education, advocacy and demonstration GSA convenes seafood
                  industry leaders, academia and NGOs to collaborate on
                  cross-cutting issues like environmental and social
                  responsibility, animal health and welfare, food safety and
                  more. GSA is a membership-driven organization. Members include
                  certified producers, corporations and individuals.{" "}
                </p>
                <p>For more detailed information about GAA go to:</p>
                <a
                  href="https://www.globalseafood.org/  "
                  target="black"
                  style={{ color: "#704fe6", fontWeight: "600" }}
                >
                  www.globalseafood.org
                </a>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 order-1 order-md-2">
              <div className="it-sv-details-top-thumb">
                <img src={partners02} alt="" />
              </div>
            </div>
          </div>
          <div className="row mb-0 mb-md-5">
            <div className="col-xl-4 col-lg-4">
              <div className="it-sv-details-top-thumb">
                <img src={partners03} alt="" />
              </div>
            </div>
            <div className="col-xl-8 col-lg-8">
              <div className="it-sv-details-top-content">
                <p>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    The Institution of Aquaculture Singapore
                  </span>{" "}
                  was started in 2014 by twelve experienced professionals with
                  the vision to use their experience and expertise to develop
                  aquaculture to greater heights. They strive to develop
                  sustainable aquaculture industry in Singapore through
                  collaborations with international aquaculture associations and
                  societies. They publish articles in FAO, GAA and other
                  magazines
                </p>
                <p>For more detailed information about WAS go to:</p>
                <a
                  href="https://www.aquanet.com/singapore/singapore/aquaculture-aquaponics/institution-of-aquaculture-singapore"
                  target="black"
                  style={{ color: "#704fe6", fontWeight: "600" }}
                >
                  www.aquanet.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PartnersSection;
